import React, { Component } from "react";
// import Edit from '../assets/edit.svg'
// import specialcustomer from '../assets/specialcustomer.svg'
// import {OverlayTrigger,Tooltip} from 'react-bootstrap'
import Tooltip from "@mui/material/Tooltip";
import { Icon } from "@iconify/react";
import outlineInfo from "@iconify/icons-ic/outline-info";

export default class FacturesReportInfo extends Component {
  render() {
    return (
      <div
        style={{ display: "flex", flexDirection: "row", alignItems: "center" }}
      >
        <Tooltip title="نمایش جزییات">
          <div
            style={{ cursor: "pointer", userSelect: "none" }}
            onClick={() => this.props.showDetails(this.props.value)}
          >
            <Icon
              icon={outlineInfo}
              width="20"
              height="20"
              style={{ color: "var(--brown1)" }}
            />
          </div>
        </Tooltip>
      </div>
    );
  }
}
